export default __webpack_public_path__ + "static/media/element2.075e6c65.svg";